<template>
  <div class="ticketstatus-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('ticketstatus_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-ticket</v-icon>{{$t('ticket.ticketstatuses')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <TicketstatusFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.name" slot-scope="{ item }">
            <v-chip
              class="ma-1 font-weight-bold"
              label
              :color="statuscolor(item)"
            >
              <v-icon left v-if="item.init">
                mdi-new-box
              </v-icon>
              <v-icon left v-if="item.finish">
                mdi-flag-checkered
              </v-icon>
              <v-icon left v-if="! item.finish && ! item.init">
                mdi-cached
              </v-icon>
              <span >{{ item.name }}</span>
            </v-chip>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import TicketstatusFilterForm from '../../components/ticketstatus/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'TicketstatusList',
  servicePrefix: 'Ticketstatus',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    TicketstatusFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('global.namefr'), value: 'namefr' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('ticketstatus', {
      items: 'list'
    }),
    ...mapFields('ticketstatus', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('ticketstatus', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    statuscolor(status) {
      if (status.important) {
        return 'error';
      }
      if (status.init) {
        return 'primary';
      }
      if (status.finish) {
        return 'success';
      }
      return 'accent';
    }
  }
};
</script>
